import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import MusicGenres from "../../../shared/MusicGenres";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Input from "../../UploadComponents/Input";
import { useFormik } from "formik";
import * as Yup from "yup";
import PostToNewsfeedToggle from "../../UploadComponents/PostToNewsfeedToggle";
import DatePicker from "../../UploadComponents/DatePicker";
import PreviewImage from "../../UploadComponents/PreviewImage";
import { createAlbum } from "../../../../../api/albums";
import { Spinner } from "react-bootstrap";

function Album() {
  const current_user = useSelector(({ current_user }: any) => current_user);
  const history = useHistory();
  const {
    handleSubmit,
    handleChange,
    setFieldError,
    values,
    isSubmitting,
    isValid,
    errors,
  } = useFormik({
    initialValues: {
      title: "",
      description: "",
      label: "",
      download_link: "",
      post_on_create: false,
      release_date: new Date(),
      preview_image: null as any,
      tags: [],
    },
    validationSchema: Yup.object({
      title: Yup.string().required(),
      label: Yup.string(),
      download_link: Yup.string().url(),
      post_on_create: Yup.boolean(),
      release_date: Yup.date().nullable(),
      description: Yup.string(),
    }),
    onSubmit: async (values) => {
      try {
        let {
          data: { album },
        } = await createAlbum({
          title: values.title,
          description: values.description,
          label: values.label,
          download_link: values.download_link,
          post_on_create: values.post_on_create,
          release_date: values.release_date,
          preview_image_id: values.preview_image?.id,
          tags: values.tags,
        });
        history.push(`/upload/albums/${album.id}/upload_tracks`);
      } catch (err) {
        setFieldError(
          "general",
          err.response.data.errors?.map((error: any) => error.message)
        );
      }
    },
  });

  const setValue = (name: any) => (value: any) => {
    return handleChange({ target: { name, value } });
  };

  console.log(values, isValid, isSubmitting, errors);

  return (
    <div
      id="upload-album"
      className="flex-grow-1 d-flex flex-column justify-content-between m-4"
    >
      <h1>Upload an Album </h1>
      <div className="d-block mb-4">
        <div className="d-xl-flex mt-4">
          <PreviewImage
            previewImage={values.preview_image}
            onChange={setValue("preview_image")}
            checkCoverSizeValidation
          />
          <div className="flex-grow-1 mx-3">
            <Input
              errors={errors.title}
              placeholder="Title"
              label="Title"
              type="text"
              name="title"
              value={values.title}
              onChange={handleChange}
            />
            <Input
              placeholder="By"
              label="By"
              type="text"
              disabled
              value={current_user.username}
            />
            <Input
              placeholder="Label"
              label="Label"
              type="text"
              value={values.label}
              name="label"
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

      <Input
        placeholder="Download link"
        label="Download Link"
        type="text"
        lablePosition="top"
        errors={errors.download_link}
        name="download_link"
        value={values.download_link}
        onChange={handleChange}
      />

      <Input
        lablePosition="top"
        placeholder="description"
        label="Description"
        type="textarea"
        name="description"
        value={values.description}
        onChange={handleChange}
      />

      <div className="genres mb-5">
        <label> Genre(s):</label>
        <MusicGenres defaultChecked={[]} onChange={setValue("tags")} />
      </div>
      <PostToNewsfeedToggle
        onChange={setValue("post_on_create")}
        value={values.post_on_create}
      />
      <DatePicker
        onChange={setValue("release_date")}
        selected={values.release_date}
      />
      {Object.keys(errors).length ? (
        <div className="alert alert-danger">
          {Object.keys(errors)
            // @ts-ignore
            .map((key: string) => errors[key])
            .join(", ")}
        </div>
      ) : null}
      <div className="py-5">
        <div className="d-flex flex-column align-items-center">
          <button
            // @ts-ignore
            onClick={handleSubmit}
            disabled={!isValid}
            className={`btn btn-primary btn-md ${!isValid ? "disabled" : ""}`}
          >
            {isSubmitting && (
              <Spinner animation={"border"} size={"sm"} className="mr-3" />
            )}
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default Album;
